import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
const CategoryUSPBlock = Joi.object({
  type: Joi.string().valid('categoryUSPBlock').required(),
  code: Joi.string().allow('', null).required(),
  icons: Joi.array().items(Joi.object({
    icon: Joi.string().required(),
    title: Joi.string().allow('', null).required(),
    content: Joi.string().allow('', null).required(),
    itemId: Joi.string().required(),
    link: linkSchema.allow('', null),
    buttonText: Joi.string().allow('', null)
  }).unknown(true)),
  ...blockAppearanceSchema
}).unknown(true);
export default CategoryUSPBlock;